export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_Amazon-Web-Service-342e42be05b0dec30df67fb296451b53.jpg";